import RouterViewBody from '~/views/RouterViewBody.vue'
import store from '~/store/index.js'
const interfaceGroups = store.getters['interfaceGroup/interfaceGroupIdList']
export default [
  {
    path: 'mob',
    component: RouterViewBody,
    meta: {
      breadCrumb: 'Mobile',
    },
    children: [
      {
        path: '',
        name: 'settingInterfaceMob',
        component: () => import('~/views/settingPage/interface/settingInterfaceMob.vue'),
      },
      {
        path: 'menu',
        name: 'settingInterfaceMob_menu',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) => translation.pages['mob_menu'].buttons.menyu,
        },
        children: [
          {
            path: 'buttons',
            name: 'settingInterfaceMob_menu_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.menu.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'login',
        name: 'settingInterfaceMob_login',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) => translation.pages['mob_login'].labels.vhod,
        },
        children: [
          {
            path: 'buttons',
            name: 'settingInterfaceMob_login_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.login.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
          {
            path: 'inputs',
            name: 'settingInterfaceMob_login_inputs',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.login.inputs,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.inputs,
            },
          },
          {
            path: 'labels',
            name: 'settingInterfaceMob_login_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.login.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
        ],
      },
      {
        path: 'registration',
        name: 'settingInterfaceMob_registration',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) =>
            translation.pages['mob_registration'].titles['sozdanie-parolya'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMob_registration_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.registration.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'labels',
            name: 'settingInterfaceMob_registration_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.registration.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_registration_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.registration.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'invitation',
        name: 'settingInterfaceMob_invitation',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) =>
            translation.pages['mob_invitation'].titles['priglashenie-v-proapp'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMob_invitation_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.invitation.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'labels',
            name: 'settingInterfaceMob_invitation_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.invitation.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_invitation_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.invitation.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'restore',
        name: 'settingInterfaceMob_restore',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) =>
            translation.pages['mob_restore'].labels['vosstanovlenie-parolya'],
        },
        children: [
          {
            path: 'buttons',
            name: 'settingInterfaceMob_restore_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.restore.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
          {
            path: 'inputs',
            name: 'settingInterfaceMob_restore_inputs',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.restore.inputs,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.inputs,
            },
          },
          {
            path: 'labels',
            name: 'settingInterfaceMob_restore_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.restore.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
        ],
      },
      {
        path: 'personal-area',
        name: 'settingInterfaceMob_personalArea',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) =>
            translation.pages['mob_personal_area'].titles['lichnyy-kabinet'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMob_personalArea_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.personalArea.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'sections',
            name: 'settingInterfaceMob_personalArea_sections',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.personalArea.sections,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.sections,
            },
          },
          {
            path: 'labels',
            name: 'settingInterfaceMob_personalArea_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.personalArea.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_personalArea_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.personalArea.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'agreement',
        name: 'settingInterfaceMob_agreement',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) => translation.pages['agreement'].labels['name_agreement'],
        },
        children: [
          {
            path: 'labels',
            name: 'settingInterfaceMob_agreement_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.agreement.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_agreement_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.agreement.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'working-time',
        name: 'settingInterfaceMob_workingTime',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) =>
            translation.pages['mob_menu'].buttons['kontrol-rabochego-vremeni'],
        },
        children: [
          {
            path: 'titles',
            name: 'settingInterfaceMob_workingTime_titles',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.workingTime.titles,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
            },
          },
          {
            path: 'text',
            name: 'settingInterfaceMob_workingTime_text',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.workingTime.text,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.texts,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_workingTime_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.workingTime.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
          {
            path: 'report',
            name: 'settingInterfaceMob_workingTimeReport',
            redirect: {
              name: 'settingInterfaceMob',
            },
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              breadCrumbLocalStorage: 'mobile',
              breadCrumb: (translation) =>
                translation.pages['mob_working_time-report'].titles['otchety'],
            },
            children: [
              {
                path: 'titles',
                name: 'settingInterfaceMob_workingTimeReport_titles',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.mob.workingTime.report.titles,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.titles,
                },
              },
              {
                path: 'sections',
                name: 'settingInterfaceMob_workingTimeReport_sections',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.mob.workingTime.report.sections,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.sections,
                },
              },
              {
                path: 'labels',
                name: 'settingInterfaceMob_workingTimeReport_labels',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.mob.workingTime.report.labels,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
                },
              },
              {
                path: 'buttons',
                name: 'settingInterfaceMob_workingTimeReport_buttons',
                component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
                meta: {
                  interfaceGroupId: interfaceGroups.mob.workingTime.report.buttons,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) =>
                    translation.pages['setting-interface'].common.buttons,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'projects',
        name: 'settingInterfaceMob_projects',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.proekty,
        },
        children: [
          {
            path: 'sections',
            name: 'settingInterfaceMob_projects_sections',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.projects.sections,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.sections,
            },
          },
        ],
      },
      {
        path: 'modal',
        name: 'settingInterfaceMob_modal',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages['setting-interface'].common.dialogs,
        },
        children: [
          {
            path: 'add-photo',
            name: 'settingInterfaceMob_modal_addPhoto',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.modal.addPhoto,
              breadCrumbLocalStorage: 'mobile',
              breadCrumb: (translation) => translation.pages['mob_modal'].add_photo['dobavit-foto'],
            },
          },
          {
            path: 'common',
            name: 'settingInterfaceMob_modal_common',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.modal.common,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.elements,
            },
          },
        ],
      },
      {
        path: 'calendar',
        name: 'settingInterfaceMob_calendar',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'mobile',
          breadCrumb: (translation) => translation.pages['mob_menu'].buttons['calendar'],
        },
        children: [
          {
            path: 'labels',
            name: 'settingInterfaceMob_calendar_labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.calendar.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
          {
            path: 'buttons',
            name: 'settingInterfaceMob_agreement_buttons',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.agreement.buttons,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.buttons,
            },
          },
        ],
      },
      {
        path: 'push',
        name: 'settingInterfaceMob-push',
        redirect: {
          name: 'settingInterfaceMob',
        },
        component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['push_notifications'],
        },
        children: [
          {
            path: 'labels',
            name: 'settingInterfaceMob-push-labels',
            component: () => import('~/views/settingPage/interface/settingInterfaceEdit.vue'),
            meta: {
              interfaceGroupId: interfaceGroups.mob.push.labels,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-interface'].common.labels,
            },
          },
        ],
      },
    ],
  },
]
